import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721908ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-container" }
const _hoisted_2 = {
  key: 0,
  class: "dots"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "info-container" }
const _hoisted_6 = { class: "step-name" }
const _hoisted_7 = {
  key: 0,
  style: {"flex":"1","display":"flex","justify-content":"flex-end"}
}
const _hoisted_8 = { class: "date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newSteps || $props.steps, (step, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["step", { 'step-active': step.active }])
      }, [
        ($props.steps[index - 1])
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ion_icon, {
            icon: step.active ? $setup.checkmarkCircle : $setup.checkmarkCircleOutline
          }, null, 8, ["icon"]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(step.name), 1),
          (step.hour)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString($setup.extractTime(step.hour)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    }), 128))
  ]))
}